module.exports = __webpack_public_path__ + "img/logo_monocolor.d3e0a3fa.svg";